import React,{useContext, useEffect} from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom"
import {useTranslation} from 'react-i18next';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Chip,
  Link,
} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';
import Icon from '@mdi/react';
import {
  mdiUndo,
  mdiFileEditOutline,
  mdiInboxArrowDown,
  mdiProgressCheck,
  mdiCheck,
  mdiCancel,
  mdiEmailEditOutline,
} from '@mdi/js';


import {UserRole,Language,RequestStatusId,RequestActionId,SnackbarSeverity} from '../../../ApplicationConfig/constants'

import {TabPreferences} from '../../../StateObjects/TabPreferences'
import {UserPreferencesContext} from '../../../StateObjects/UserPreferencesContext';

import AnalystCell from './AnalystCell';
import ActionsMenu from './ContextMenu';
import DashboardTableHead from './DashboardTableHead';
import Snackbar from '../../CommonComponents/Snackbar';
import {
  DialogWithdraw,
  DialogNoLead,
  DialogAssign,
  DialogRequesterDetails,
  DialogAssigneeDetails,
  DialogUpdate,
  DialogDenied,
  DialogApproved,
  DialogDelete
} from '../../CommonComponents/DialogBox';

import {UserInfoContext} from '../../../StateObjects/UserInfoContext';
import {ProjectInfoContext} from '../../../StateObjects/ProjectInfoContext';

import {Auth} from '../../../Api/auth';

import {formatDate} from '../../../Utilities/functions';
import { useMsal } from '@azure/msal-react';

const PREFIX = 'ROW_HEIGHT';

const classes = {
  tableContainer: `${PREFIX}-tableContainer`,
  tablePagination: `${PREFIX}-tablePagination`,
  table: `${PREFIX}-table`,
  tablesCellsFlex: `${PREFIX}-tablesCellsFlex`,
  tableRow: `${PREFIX}-tableRow`,
  statusCell: `${PREFIX}-statusCell`,
  status: `${PREFIX}-status`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.tableContainer}`]: {
    backgroundColor: theme.palette.common.white,
    width: 'auto',
    padding: theme.spacing(0, 2, 2, 2),
    paddingBottom: 0,
  },

  [`& .${classes.tablePagination}`]: {
    backgroundColor: theme.palette.common.white,
    borderTop: '1px solid',
    borderTopColor: theme.palette.divider,
  },

  [`& .${classes.table}`]: {
    padding: 0,
  },

  [`& .${classes.tablesCellsFlex}`]: {
    display: 'flex',
    alignItems: 'center',
    minHeight: `calc(${ROW_HEIGHT}px - ${theme.spacing(2)})`,
  },

  [`& .${classes.tableRow}`]: {
    height: ROW_HEIGHT,
  },

  [`& .${classes.statusCell}`]: {
    display: 'flex',
  },

  [`& .${classes.status}`]: {
    'paddingLeft': theme.spacing(1),
    '&:first-letter': {
      textTransform: 'capitalize',
    },
  }
}));

export const ROW_HEIGHT = 58;

export default function TableContainerComponent(props) {

  const {instance}=useMsal();

  const {userPreferences,setUserPreferences} = useContext(UserPreferencesContext);
 
  const {
    statusHead,
    setBackdropOpen,
    getPageRequestData,
    requestsInfo,
    setRequestsInfo,
  }=props
   
  var initOrder='desc'
  var initOrderBy='updatedOn'
  var initRowsPerPage=userPreferences.dashboard.rowsPerPage

  if (userPreferences.dashboard.tabs[props.status]!=undefined){
    initOrder=userPreferences.dashboard.tabs[props.status].orderingOrder
    initOrderBy=userPreferences.dashboard.tabs[props.status].orderingColumn
  }

  const [order, setOrder] = React.useState(initOrder);
  const [page, setPage] = React.useState(0);

  const [orderBy, setOrderBy] = React.useState(initOrderBy);
  const [rowsPerPage, setRowsPerPage] = React.useState(initRowsPerPage);

  const [open, setOpen] = React.useState({
    dialogAssigneeDetails: false,
    dialogRequesterDetails: false,
    dialogAssignAsLead: false,
    dialogAssignAsSupport: false,
    dialogNoLead: false,
    dialogWithdraw: false,
    dialogUpdate: false,
    dialogDenied: false,
    dialogApproved:false,
    dialogDelete:false,
  });

  const {t,i18n} = useTranslation();
  const [dialogData,setDialogData]=React.useState({
    rowUserInfo:{
      fullName:'default',
      phoneNumber:'0000000000',
      account:'default'
    },
    supportAnalysts:[],
    data: null
  })

  const history=useHistory();


  const [snackbarState, setSnackbarState] = React.useState({
    open: false,
    severity: "success",
    message: "",
    snackbarDenied: false,
    snackbarApproved: false,
    snackbarUpdate: false,
    snackbarWithdraw: false,
    snackbarDelete: false,
    snackbarAssignPrimary: false,
    snackbarAssignSupport: false,
    snackbarNoLead: false,
  });
  
  const handleCloseSnackbar=(snack)=>{
    setSnackbarState({...snackbarState,
      [snack]: false,
      message: ""
    });
  }

  const handleCloseSnackbars=()=>{
    setSnackbarState({
      open: false,
      severity: "success",
      message: "",
      snackbarDenied: false,
      snackbarApproved: false,
      snackbarUpdate: false,
      snackbarWithdraw: false,
      snackbarDelete: false,
      snackbarAssignPrimary: false,
      snackbarAssignSupport: false,
      snackbarNoLead: false,
    });
  }
 
  const {userInfo} = useContext(UserInfoContext);
  const {projectInfo, setProjectInfo} = useContext(ProjectInfoContext);

  useEffect(() => {
    getPageRequestData(false, props.status, page, rowsPerPage, orderBy, order);

    return ()=>{
      setBackdropOpen(false);
    }
  }, [projectInfo.id, props.status, page, rowsPerPage, orderBy, order]);

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, requestsInfo.maxRows - page * rowsPerPage);
  
  function toggleDialog(state,value,rowInfo,supportAnalysts=[]) {
    if (rowInfo!=null){ 
      if(state==="dialogAssigneeDetails" || state==="dialogRequesterDetails"){
        setDialogData({...dialogData, rowUserInfo:rowInfo,supportAnalysts:supportAnalysts});
      }else{
        setDialogData({...dialogData, data: rowInfo});
      }
    }
    
    setOpen({...open, [state]:value});
  }

  const statusIcon = (value) => {
    switch (value) {
      case RequestStatusId.Withdrawn:
        return <Icon path={mdiUndo} size={1} className={classes.statusIcon} />;
      case RequestStatusId.Draft:
        return (
          <Icon
            path={mdiFileEditOutline}
            size={1}
            className={classes.statusIcon}
          />
        );
      case RequestStatusId.Submitted:
        return (
          <Icon
            path={mdiInboxArrowDown}
            size={1}
            className={classes.statusIcon}
          />
        );
      case RequestStatusId.DisclosureAnalysis:
        return (
          <Icon
            path={mdiProgressCheck}
            size={1}
            className={classes.statusIcon}
          />
        );
      case RequestStatusId.Approved:
        return <Icon path={mdiCheck} size={1} className={classes.statusIcon} />;
      case RequestStatusId.Denied:
        return (
          <Icon path={mdiCancel} size={1} className={classes.statusIcon} />
        );
      case RequestStatusId.UpdateRequest:
        return (
          <Icon
            path={mdiEmailEditOutline}
            size={1}
            className={classes.statusIcon}
          />
        );
      default:
        return;
    }
  };

  useEffect(()=>{
    var tabPref={...TabPreferences}
    
    tabPref.orderingOrder=order;
    tabPref.orderingColumn=orderBy;
    
    userPreferences.dashboard.rowsPerPage=rowsPerPage;
    userPreferences.dashboard.tabs[props.status]=tabPref

    setUserPreferences(userPreferences);
  },[rowsPerPage,order,orderBy])
  
  //track the number of rows left on the current page
  useEffect(()=>{
    if (rowsPerPage==emptyRows && page>0){
      setPage(page-1);
    }
  },[emptyRows])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  React.useEffect(()=>{
    setPage(0);
    setRequestsInfo({rows: [], maxRows: 0});
  },[projectInfo.id])

  const [rowRefresh, setRowRefresh] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (!rowRefresh){
        getPageRequestData(true, props.status, page, rowsPerPage, orderBy, order);
      }
    }, 60000);
    return ()=>clearTimeout(timer)
  });

  const refreshRow=()=>{
    setRowRefresh(true);
    getPageRequestData(false, props.status, page, rowsPerPage, orderBy, order);
    setRowRefresh(false);
  }

  const handleSubmitAction=(rowUpdateInfo)=>{
    let requestOptions = {
      method:"POST", 
      headers:{'Content-type':'application/json'},
      body: JSON.stringify({request_id:rowUpdateInfo.requestId})
    }

    setBackdropOpen(true);
    Auth.authorizedFetch("/api/submitRequest", requestOptions,instance)
    .then(res=> res.json())
    .then(result=>{
      if(result.statusCode===200){
        setSnackbarState({...snackbarState, open: true, severity: rowUpdateInfo.severity, message: rowUpdateInfo.message});
        refreshRow();
      }else{
        if(Object.prototype.hasOwnProperty.call(result.data, "formErrors")){
          let errorCount = 0;
          Object.keys(result.data.formErrors).forEach(k=>{
            errorCount+=Object.keys(result.data.formErrors[k]).length;
          });
          if(errorCount > 99){
            setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.request.intenseFormErrors")});
          }else{
            setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.request.formErrors", {count: errorCount})});
          }
        }else if(Object.prototype.hasOwnProperty.call(result.data, "invalidOutputs")){
          setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.request.invalidFiles")});
        }else if(Object.prototype.hasOwnProperty.call(result, "customMessageKey")){
          setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.request." + result.customMessageKey)});
        }else if(Object.prototype.hasOwnProperty.call(result.data, "failedFiles")){
          setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.request.copyError")});
        }else{
          setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.request.submitError")});
        }
      }
    })
    .catch(()=> {
      setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.request.submitError")});
    })
    .finally(()=>{
      setBackdropOpen(false);
    });
  }

  const handleUnassignAnalyst=(rowStatus)=>{
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ request_id: rowStatus.requestId})
    };
    setBackdropOpen(true);
    var success=true;
    Auth.authorizedFetch("/api/unassignMyself",requestOptions,instance)
    .then(res=>res.json())
    .then((result)=>{
        if (result.statusCode!=200){
          setSnackbarState({...snackbarState, snackbarNoLead: true, severity: "error", message: t("applicationErrorMessage.generic." + result.customMessageKey)});
          success=false;
        }
        else{
          setSnackbarState({...snackbarState, snackbarNoLead: true, severity: "success", message: rowStatus.message});
          refreshRow();
        }
    })
    .catch(()=>{
      setSnackbarState({...snackbarState, snackbarNoLead: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
      success=false;
    })
    .finally(()=>{
      setBackdropOpen(false);
    });

    return success;
  }

  const handleAssignSupportAnalyst=(rowStatus)=>{
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ request_id: rowStatus.requestId,phone_number:rowStatus.phoneNumber})
    };
    let snack = "snackbarAssignSupport";
    if(rowStatus.hasOwnProperty("noLead") && rowStatus.noLead){
      snack = "snackbarNoLead";
    }

    setBackdropOpen(true);
    Auth.authorizedFetch("/api/assignAsSupportAnalyst",requestOptions,instance)
    .then(res=>res.json())
    .then((result)=>{
        if (result.statusCode!=200){
          setSnackbarState({...snackbarState, [snack]: true, severity: "error", message: t("applicationErrorMessage.request." + result.customMessageKey)});
        }else{
          setSnackbarState({...snackbarState, [snack]: true, severity: "success", message: rowStatus.message});
          refreshRow();
        }
      }
    )
    .catch(()=>{
      setSnackbarState({...snackbarState, [snack]: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
    })
    .finally(()=>{
      setBackdropOpen(false);
    });
  }

  const handleAssignPrimaryAnalyst=(rowStatus)=>{
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ request_id: rowStatus.requestId,phone_number:rowStatus.phoneNumber})
    };

    var success=true
    setBackdropOpen(true);
    Auth.authorizedFetch("/api/assignAsPrimaryAnalyst",requestOptions,instance)
    .then(res=>res.json())
    .then((result)=>{
      if (result.statusCode!=200){
        setSnackbarState({...snackbarState, snackbarAssignPrimary: true, severity: "error", message: t("applicationErrorMessage.request." + result.customMessageKey)});
        success=false;
      }
      else{
        setSnackbarState({...snackbarState, snackbarAssignPrimary: true, severity: "success", message: rowStatus.message});
        refreshRow();
      }
    })
    .catch(()=>{
      setSnackbarState({...snackbarState, snackbarAssignPrimary: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
      success=false;
    })
    .finally(()=>{
      setBackdropOpen(false);
    });

    return success;
  }

  const handleReactivateRequest=(rowStatus)=>{
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ request_id: rowStatus.requestId,
      phone_number:rowStatus.phoneNumber})
    };
    setBackdropOpen(true);
    Auth.authorizedFetch("/api/reactivateRequest",requestOptions,instance)
    .then(res=>res.json())
    .then((result)=>{
      if(result.statusCode==200){
        history.push("/" + i18n.language + "/request/"+rowStatus.requestId);
      }else if (result.statusCode==400){
        setSnackbarState({...snackbarState, snackbarAssignPrimary: true, severity: "error", message: t("applicationErrorMessage.generic." + result.customMessageKey)});
        setBackdropOpen(false);
      }
      else{
        setSnackbarState({...snackbarState, snackbarAssignPrimary: true, severity: "error", message: t("applicationErrorMessage.request." + result.customMessageKey)});
        setBackdropOpen(false);
      }
    })
    .catch(()=>{
      setSnackbarState({...snackbarState, snackbarAssignPrimary: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
      setBackdropOpen(false);
    });
  }

  const handleStartDisclosureAnalysis=(rowStatus)=>{
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ request_id: rowStatus.requestId,new_status_id:rowStatus.actionId})
    };
    setBackdropOpen(true);
    Auth.authorizedFetch("/api/updateRequestStatus",requestOptions,instance)
    .then(res=>res.json())
    .then((result)=>{
      if(result.statusCode==200){
        history.push("/" + i18n.language + "/request/"+rowStatus.requestId);
      }else if (result.statusCode==400){
        setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.generic." + result.customMessageKey)});
        setBackdropOpen(false);
      }else{
        setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.request." + result.customMessageKey)});
        setBackdropOpen(false);
      }
    })
    .catch(()=>{
      setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
      setBackdropOpen(false);
    });
  }

  const handleDenyRequest=(rowData)=>{
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({request_id:rowData.requestId,
        reason_id:rowData.reasonId,
        billable_hours:rowData.billableHours,
        billable_minutes:rowData.billableMinutes
      })
    };
    setBackdropOpen(true);
    Auth.authorizedFetch("/api/denyRequest", requestOptions,instance)
    .then(res=>res.json())
    .then(data=>{
      if(data.statusCode===200){
        setSnackbarState({...snackbarState, snackbarDenied: true, severity: "success", message: rowData.message});
        refreshRow();
      }else{
        if(Object.prototype.hasOwnProperty.call(data.data, "formErrors")){
          let errorCount = 0;
          Object.keys(data.data.formErrors).forEach(k=>{
            errorCount+=Object.keys(data.data.formErrors[k]).length;
          });
          if(errorCount > 99){
            setSnackbarState({...snackbarState, snackbarDenied: true, severity: "error", message: t("applicationErrorMessage.request.intenseFormErrors")});
          }else{
            setSnackbarState({...snackbarState, snackbarDenied: true, severity: "error", message: t("applicationErrorMessage.request.formErrors", {count: errorCount})});
          }
        }else if(Object.prototype.hasOwnProperty.call(data, "customMessageKey") && i18n.exists("applicationErrorMessage.generic." + data.customMessageKey)){
          setSnackbarState({...snackbarState, snackbarDenied: true, severity: "error", message: t("applicationErrorMessage.generic." + data.customMessageKey)});
        }else if(Object.prototype.hasOwnProperty.call(data, "customMessageKey") && i18n.exists("applicationErrorMessage.request." + data.customMessageKey)){
          setSnackbarState({...snackbarState, snackbarDenied: true, severity: "error", message: t("applicationErrorMessage.request." + data.customMessageKey)});
        }else{
          setSnackbarState({...snackbarState, snackbarDenied: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
        }
      }
    })
    .catch(()=>{
      setSnackbarState({...snackbarState, snackbarDenied: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
    })
    .finally(()=>{
      setBackdropOpen(false);
    });
  }

  const handleApproveRequest=(rowData)=>{
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({request_id:rowData.requestId, 
        billable_hours:rowData.billableHours,
        billable_minutes:rowData.billableMinutes
      })
    };
    setBackdropOpen(true);
    Auth.authorizedFetch("/api/approveRequest", requestOptions,instance)
    .then(res=>res.json())
    .then(data=>{
      if(data.statusCode===200){
        setSnackbarState({...snackbarState, snackbarApproved: true, severity: "success", message: rowData.message});
        refreshRow();
      }else{
        if(Object.prototype.hasOwnProperty.call(data.data, "formErrors")){
          let errorCount = 0;
          Object.keys(data.data.formErrors).forEach(k=>{
            errorCount+=Object.keys(data.data.formErrors[k]).length;
          });
          if(errorCount > 99){
            setSnackbarState({...snackbarState, snackbarApproved: true, severity: "error", message: t("applicationErrorMessage.request.intenseFormErrors")});
          }else{
            setSnackbarState({...snackbarState, snackbarApproved: true, severity: "error", message: t("applicationErrorMessage.request.formErrors", {count: errorCount})});
          }
        }else if(Object.prototype.hasOwnProperty.call(data, "customMessageKey") && i18n.exists("applicationErrorMessage.generic." + data.customMessageKey)){
          setSnackbarState({...snackbarState, snackbarApproved: true, severity: "error", message: t("applicationErrorMessage.generic." + data.customMessageKey)});
        }else if(Object.prototype.hasOwnProperty.call(data, "customMessageKey") && i18n.exists("applicationErrorMessage.request." + data.customMessageKey)){
          setSnackbarState({...snackbarState, snackbarApproved: true, severity: "error", message: t("applicationErrorMessage.request." + data.customMessageKey)});
        }else{
          setSnackbarState({...snackbarState, snackbarApproved: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
        }
      }
    })
    .catch(()=>{
      setSnackbarState({...snackbarState, snackbarApproved: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
    })
    .finally(()=>{
      setBackdropOpen(false);
    });
  };

  const handleRequestUpdate=(rowData)=>{
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({request_id: rowData.requestId})
    };
    setBackdropOpen(true);
    Auth.authorizedFetch("/api/requestUpdate", requestOptions,instance)
    .then(res=>res.json())
    .then(result=>{
      if(result.statusCode===200){
        setSnackbarState({...snackbarState, snackbarUpdate: true, severity: "success", message: rowData.message});
        refreshRow();
      }else{
        if(Object.prototype.hasOwnProperty.call(result, "customMessageKey") && i18n.exists("applicationErrorMessage.generic." + result.customMessageKey)){
          setSnackbarState({...snackbarState, snackbarUpdate: true, severity: "error", message: t("applicationErrorMessage.generic." + result.customMessageKey)});
        }else if(Object.prototype.hasOwnProperty.call(result, "customMessageKey") && i18n.exists("applicationErrorMessage.request." + result.customMessageKey)){
          setSnackbarState({...snackbarState, snackbarUpdate: true, severity: "error", message: t("applicationErrorMessage.request." + result.customMessageKey)});
        }else{
          setSnackbarState({...snackbarState, snackbarUpdate: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
        }
      }
    })
    .catch(()=>{
      setSnackbarState({...snackbarState, snackbarUpdate: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
    })
    .finally(()=>{
      setBackdropOpen(false);
    });
  };

  const handleWithdrawRequest=(rowStatus)=>{
    var requestBody={
      request_id: rowStatus.requestId,
      new_status_id: rowStatus.actionId,
      status_reason_id: rowStatus.reason_id
    }
   
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody)
    };

    setBackdropOpen(true);
    Auth.authorizedFetch("/api/updateRow",requestOptions,instance)
    .then(res => res.json())
    .then((result) => {
      if (result.statusCode!=200){
        if (result.customMessageKey=='invalidProject'){
          setProjectInfo(userInfo.projects.find(proj => proj.id===result.data.projectId))
        }
        setSnackbarState({...snackbarState, snackbarWithdraw: true, severity: "error", message: t("applicationErrorMessage.request." + result.customMessageKey)});
      }else {
        setSnackbarState({...snackbarState, snackbarWithdraw: true, severity: "success", message: rowStatus.message});
        refreshRow();
      }
    })
    .catch(()=>{
      setSnackbarState({...snackbarState, snackbarWithdraw: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
    })
    .finally(()=>{
      setBackdropOpen(false);
    });
  }

  const handleDeleteRequest=(rowStatus)=>{
    var requestBody={
      request_id: rowStatus.requestId,
      new_status_id: rowStatus.actionId
    }
   
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody)
    };

    setBackdropOpen(true);
    Auth.authorizedFetch("/api/updateRow",requestOptions,instance)
    .then(res => res.json())
    .then((result) => {
      if (result.statusCode!=200){
        if (result.customMessageKey=='invalidProject'){
          setProjectInfo(userInfo.projects.find(proj => proj.id===result.data.projectId))
        }
        setSnackbarState({...snackbarState, snackbarDelete: true, severity: "error", message: t("applicationErrorMessage.request." + result.customMessageKey)});
        
      }else {
        setSnackbarState({...snackbarState, snackbarDelete: true, severity: "success", message: rowStatus.message});
        refreshRow();
      }
    })
    .catch(()=>{
      setSnackbarState({...snackbarState, snackbarDelete: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
    })
    .finally(()=>{
      setBackdropOpen(false);
    });
  }

  const handleChangeStatus=(rowStatus)=>{
    var requestBody={ request_id: rowStatus.requestId,new_status_id:rowStatus.actionId}
   
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody)
    };

    setBackdropOpen(true);
    Auth.authorizedFetch("/api/updateRow",requestOptions,instance)
    .then(res => res.json())
    .then((result) => {
      if (result.statusCode!=200){
        if (result.customMessageKey=='invalidProject'){
          setProjectInfo(userInfo.projects.find(proj => proj.id===result.data.projectId))
        }
        setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.request." + result.customMessageKey)});
      }else {
        setSnackbarState({...snackbarState, open: true, severity: rowStatus.severity, message: rowStatus.message});
        refreshRow();
      }
    })
    .catch(()=>{
      setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
    })
    .finally(()=>{
      setBackdropOpen(false);
    });
  }

  const validateRequest=(state,value,rowUpdateInfo,callback)=>{
    let requestBody = {request_id:rowUpdateInfo.requestId};
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody)
    };
    
    Auth.authorizedFetch("/api/validateRequest", requestOptions,instance)
    .then(res=>res.json())
    .then(data=>{
      var success=true
      if(data.statusCode!=200){
        success=false;
        if(Object.prototype.hasOwnProperty.call(data.data, "formErrors")){
          let errorCount = 0;
          Object.keys(data.data.formErrors).forEach(k=>{
            errorCount+=Object.keys(data.data.formErrors[k]).length;
          });
          if(errorCount > 99){
            setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.request.intenseFormErrors")});
          }else{
            setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.request.formErrors", {count: errorCount})});
          }
        }
      }
      callback(success,state,value,rowUpdateInfo)
    })
    .catch((error)=>{
      console.log(error);
      setSnackbarState({...snackbarState, open: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
      callback(false,state,value,rowUpdateInfo)
    });
  }

  const handleActionChange=(rowUpdateInfo)=>{
    switch(rowUpdateInfo.actionId){
      case RequestActionId.View:
      case RequestActionId.Edit:
        history.push("/" + i18n.language + "/request/"+rowUpdateInfo.requestId);
        return;
      case RequestActionId.Resubmit:
      case RequestActionId.Submit:
        handleSubmitAction(rowUpdateInfo)
        return;
      case RequestActionId.OpenSummary:
        props.contextSummaryClick(null,requestsInfo.rows.filter(r=>r.id==rowUpdateInfo.requestId)[0]);
        return;
      case RequestActionId.OpenManageTeam:
        props.toggleManageTeamDrawer(null,requestsInfo.rows.filter(r=>r.id==rowUpdateInfo.requestId)[0]);
        return;
      case RequestActionId.AssignToMeSupport:
        handleAssignSupportAnalyst(rowUpdateInfo)
        return
      case RequestActionId.AssignToMePrimary:
        handleAssignPrimaryAnalyst(rowUpdateInfo)
        return
      case RequestActionId.UnassignFromMe:
        handleUnassignAnalyst(rowUpdateInfo)
        return
      case RequestActionId.ReactivateRequest:
        handleReactivateRequest(rowUpdateInfo)
        return
      case RequestStatusId.DisclosureAnalysis:
        handleStartDisclosureAnalysis(rowUpdateInfo)
        return
      case RequestStatusId.Denied:
        handleDenyRequest(rowUpdateInfo);
        return
      case RequestStatusId.Approved:
        handleApproveRequest(rowUpdateInfo);
        return
      case RequestStatusId.UpdateRequest:
        handleRequestUpdate(rowUpdateInfo)
        return
      case RequestStatusId.Withdrawn:
        handleWithdrawRequest(rowUpdateInfo);
        return
      case RequestActionId.Delete:
        handleDeleteRequest(rowUpdateInfo);
        return
      default:
        handleChangeStatus(rowUpdateInfo)
    } 
  }

  const handleDateTime = (value) => {
    var convertedValue=new Date(value);
    var currentDateTime=new Date();
    const timeDifference = currentDateTime - convertedValue;
    let time;
    // 1000ms = 1s
    // 60000ms = 1min
    // 3600000 = 1hr
    // 86400000 = 24hr

    if (timeDifference < 60000) {
      // under 1 minute
      return t('commonDashboard.updatedOn.justNow');
    } else if (timeDifference >= 60000 && timeDifference < 3600000) {
      // between 1 minute - 1 hour
      time = Math.floor(timeDifference / 60000);
      return t('commonDashboard.updatedOn.minAgo',{count:time});

    } else if (timeDifference >= 3600000 && timeDifference < 86400000) {
      // between 1 hour - 24 hours
      time = Math.floor(timeDifference / 3600000);
      return t('commonDashboard.updatedOn.hourAgo',{count:time});

    } else if (timeDifference >= 86400000) {
      // over 24 hours
      return formatDate(value,i18n.language)//month + ' ' + day + ', ' + year;
    }
  };
  
  return (
    <Root>
      <TableContainer
        className={classes.tableContainer}
      >
        <Table
          className={classes.table}
          aria-label={t('site.requestTable.vettingRequestDashboard')}
          size='medium'
          stickyHeader
        >
          <DashboardTableHead
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            headCells={props.headCells()}
          />
          <TableBody>
            {requestsInfo.rows.map((row, index) => {
              const labelId = `enhanced-table-checkbox-${index}`;
              
              return (
                <TableRow 
                  hover 
                  key={row.id} 
                  className={classes.tableRow}
                >
                  <TableCell id={labelId} className={classes.tablesCells}>
                    <Link
                      underline="hover"
                      color="inherit"
                      component={RouterLink}
                      to={'/' + i18n.language + '/request/' + row.id}
                    >
                      <Typography variant="body2" noWrap={true} component="span">{row.name}</Typography>
                      <br />
                      <Typography variant="body2" noWrap={true} component="span">ID {row.identifier}</Typography>
                    </Link>
                  </TableCell>
                  {userInfo.role==UserRole.Analyst && 
                    <TableCell>
                      <Typography
                        variant="body2"
                        noWrap={true}
                        className={classes.status}
                      >
                        {row.contractNumber}
                      </Typography>
                    </TableCell>
                  }
                  <TableCell>
                    <div className={classes.tablesCellsFlex}>
                      {statusIcon(row.status.id)}
                      <Typography 
                        variant="body2" 
                        noWrap={true} 
                        className={classes.status}
                      >
                        {i18n.language==Language.French?row.statusDescFR:row.statusDescEN}
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={row.researcher.fullName}
                      onClick={() => {
                        toggleDialog('dialogRequesterDetails',true,row.researcher)
                      }}
                    />
                  </TableCell>
                  <AnalystCell 
                    clickHandler={() => {
                      toggleDialog('dialogAssigneeDetails',true,row.primaryAnalyst,row.supportAnalysts);
                    }}
                    toggleManageTeamDrawer={props.toggleManageTeamDrawer}
                    leadAnalyst={row.primaryAnalyst} 
                    supportAnalysts={row.supportAnalysts} 
                    row={row} 
                  />
                  <TableCell>
                    <Typography variant="body2" noWrap={true}>{handleDateTime(row.createdOn)}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" noWrap={true}>{handleDateTime(row.updatedOn)}</Typography>
                  </TableCell>
                  <TableCell align='center'>
                    <ActionsMenu 
                      analyst={row.primaryAnalyst}
                      supportAnalysts={row.supportAnalysts}
                      requester={row.researcher}
                      validateRequest={validateRequest}
                      status={row.status.id} 
                      handleAction={handleActionChange} 
                      requestId={row.id} 
                      hasBeenReviewed={row.hasBeenReviewed || row.hasBeenSubmitted}
                      controls={index}
                      closeSnackbar={handleCloseSnackbars}
                      toggleDialog={toggleDialog}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 20]}
        className={classes.tablePagination}
        component="div"
        count={requestsInfo.maxRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage={t('site.requestTable.rowsPerPageLabel')}
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${t('site.requestTable.rowsPerPageCount')} ${count}`}
      />
      <DialogRequesterDetails 
        toggleDialog={() => toggleDialog('dialogRequesterDetails', false, null)}
        open={open.dialogRequesterDetails}
        account={dialogData.rowUserInfo}
      />
      <DialogAssigneeDetails
        toggleDialog={() => toggleDialog('dialogAssigneeDetails', false, null)}
        open={open.dialogAssigneeDetails}
        account={dialogData.rowUserInfo}
        supportAnalysts={dialogData.supportAnalysts}
        statusHead={statusHead}
      />
      <DialogAssign
        open={open.dialogAssignAsLead}
        toggleDialog={() => toggleDialog('dialogAssignAsLead', false, null)}
        handleAssignMeAs={handleActionChange}
        rowData={dialogData.data}
        isAssignLead={true}
        snackbar={
          <Snackbar 
            message={snackbarState.message}
            severity={snackbarState.severity}
            open={snackbarState.snackbarAssignPrimary}
            handleClose={()=>handleCloseSnackbar("snackbarAssignPrimary")}
          />
        }
      />
      <DialogAssign
        open={open.dialogAssignAsSupport}
        toggleDialog={() => toggleDialog('dialogAssignAsSupport', false, null)}
        handleAssignMeAs={handleActionChange}
        rowData={dialogData.data}
        isAssignLead={false}
        snackbar={
          <Snackbar 
            message={snackbarState.message}
            severity={snackbarState.severity}
            open={snackbarState.snackbarAssignSupport}
            handleClose={()=>handleCloseSnackbar("snackbarAssignSupport")}
          />
        }
      />
      <DialogNoLead
        open={open.dialogNoLead}
        toggleDialog={() => toggleDialog('dialogNoLead', false, null)}
        handleSubmit={() => {
          toggleDialog('dialogNoLead', false, null);
          handleActionChange(dialogData.data != null ? dialogData.data : true);
        }}
        text={{
          title: t('dialog.noLeadNoLeadAssigned'),
          titleClose: t('dialog.noLeadNoLeadClose'), 
          main: t('dialog.noLeadMainText'), 
          submit: t('dialog.noLeadContinue')
        }}
        snackbar={
          <Snackbar 
            message={snackbarState.message}
            severity={snackbarState.severity}
            open={snackbarState.snackbarNoLead}
            handleClose={()=>handleCloseSnackbar("snackbarNoLead")}
          />
        }
      />
      <DialogDelete 
        toggleDialog={() => toggleDialog('dialogDelete', false, null)} 
        rowData={dialogData.data} 
        handleDelete={handleActionChange} 
        open={open.dialogDelete} 
        snackbar={
          <Snackbar 
            message={snackbarState.message}
            severity={snackbarState.severity}
            open={snackbarState.snackbarDelete}
            handleClose={()=>handleCloseSnackbar("snackbarDelete")}
          />
        }
      />
      <DialogWithdraw
        toggleDialog={() => toggleDialog('dialogWithdraw', false, null)} 
        rowData={dialogData.data} 
        handleWithdraw={handleActionChange} 
        open={open.dialogWithdraw}
        snackbar={
          <Snackbar 
            message={snackbarState.message}
            severity={snackbarState.severity}
            open={snackbarState.snackbarWithdraw}
            handleClose={()=>handleCloseSnackbar("snackbarWithdraw")}
          />
        }
      />
      <DialogUpdate 
        toggleDialog={() => toggleDialog('dialogUpdate', false, null)} 
        rowData={dialogData.data} 
        handleUpdate={handleActionChange}
        open={open.dialogUpdate}
        snackbar={
          <Snackbar 
            message={snackbarState.message}
            severity={snackbarState.severity}
            open={snackbarState.snackbarUpdate}
            handleClose={()=>handleCloseSnackbar("snackbarUpdate")}
          />
        }
      />
      <DialogApproved 
        toggleDialog={() => toggleDialog('dialogApproved', false, null)} 
        rowData={dialogData.data} 
        handleApproved={handleActionChange} 
        open={open.dialogApproved}
        snackbar={
          <Snackbar 
            message={snackbarState.message}
            severity={snackbarState.severity}
            open={snackbarState.snackbarApproved}
            handleClose={()=>handleCloseSnackbar("snackbarApproved")}
          />
        }
      />
      <DialogDenied 
        toggleDialog={() => toggleDialog('dialogDenied', false, null)} 
        rowData={dialogData.data} 
        handleDenied={handleActionChange} 
        open={open.dialogDenied} 
        snackbar={
          <Snackbar 
            message={snackbarState.message}
            severity={snackbarState.severity}
            open={snackbarState.snackbarDenied}
            handleClose={()=>handleCloseSnackbar("snackbarDenied")}
          />
        }
      />
      <Snackbar 
        message={snackbarState.message}
        severity={snackbarState.severity}
        open={snackbarState.open}
        handleClose={()=>handleCloseSnackbar("open")}
      />
    </Root>
  );
}
TableContainerComponent.propTypes={
  statusHead: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  setBackdropOpen: PropTypes.func.isRequired,
  contextSummaryClick: PropTypes.func.isRequired,
  headCells: PropTypes.func.isRequired,
  setOpenDialog: PropTypes.func,
  toggleManageTeamDrawer: PropTypes.func,
  getPageRequestData: PropTypes.func.isRequired,
  requestsInfo: PropTypes.object.isRequired,
  setRequestsInfo: PropTypes.func.isRequired,
}